module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-circle-fill-7154c87d.svg";